import ExpandableTableForOrderAuth from "../../../components/expandableTableForOrderAuth/expandableTableForOrderAuth";

/**
 * Dev-only page for manually testing the expandable order-auth table with dummy data.
 *
 * @returns Test page shell wrapping {@link ExpandableTableForOrderAuth}
 */
const ExpandableOrderAuthTestPage = () => {
  return (
    <div className="flex h-full flex-col overflow-hidden">
      <div className="mb-4 text-h11 font-bold text-primaryGray-1">
        Expandable Order Auth — Test Page
      </div>
      <div className="flex-1 overflow-auto">
        <ExpandableTableForOrderAuth
          data={[]}
          expandedContentType="table"
          isLoading={false}
          error={null}
        />
      </div>
    </div>
  );
};

export default ExpandableOrderAuthTestPage;
